import axios from 'axios';
import qs from 'qs';

const controller = new AbortController();

if (import.meta.env.MODE === 'development' && import.meta.env.VITE_DEV_COOKIE) {
  const cookies = import.meta.env.VITE_DEV_COOKIE.split(';');
  cookies.forEach((cookie) => {
    document.cookie = cookie.trim();
  });
}

const axiosInstance = axios.create({
  signal: controller.signal,
  validateStatus: (status) => status >= 200 && status < 300,
  paramsSerializer: {
    serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  },
  withCredentials: import.meta.env.MODE === 'development',
});

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === 401) {
      controller.abort();
    }
    return Promise.reject(error);
  }
);

export { axiosInstance as HttpClient };
